import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "drama-list-card"
};
const _hoisted_2 = {
  class: "drama-basic-info"
};
const _hoisted_3 = {
  class: "info-container"
};
const _hoisted_4 = {
  class: "drama-name"
};
const _hoisted_5 = {
  style: {
    "margin-left": "1.0rem"
  }
};
const _hoisted_6 = {
  class: "detail-info-container"
};
const _hoisted_7 = {
  class: "intro"
};
const _hoisted_8 = {
  key: 0,
  class: "oddment"
};
import { ElIcon, ElImage, ElRow } from 'element-plus';
import { Film, Odometer, PriceTag, Ticket, Timer } from '@element-plus/icons-vue';
import { getDifficultyDegree } from '@/tools/utils'; // pre-declaration

export default {
  __name: 'DramaListCard',
  props: {
    data: {
      type: Object,
      required: true
    }
  },

  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("text", _hoisted_4, _toDisplayString(__props.data.name), 1), _createElementVNode("div", null, [_createVNode(_unref(ElRow), {
        class: "info-row"
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElIcon), {
          size: 14,
          style: {
            "margin-right": "0.5rem"
          }
        }, {
          default: _withCtx(() => [_createVNode(_unref(Film))]),
          _: 1
        }), _createElementVNode("text", null, "世界观： " + _toDisplayString(__props.data.world_outlook.name), 1)]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        class: "info-row"
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElIcon), {
          size: 14,
          style: {
            "margin-right": "0.5rem"
          }
        }, {
          default: _withCtx(() => [_createVNode(_unref(Ticket))]),
          _: 1
        }), _createElementVNode("text", null, "风格 ： " + _toDisplayString(__props.data.nature.desc ?? ''), 1)]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        class: "info-row"
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElIcon), {
          size: 14,
          style: {
            "margin-right": "0.5rem"
          }
        }, {
          default: _withCtx(() => [_createVNode(_unref(Odometer))]),
          _: 1
        }), _createElementVNode("text", null, "难度 ： " + _toDisplayString((__props.data.difficulty / 10).toFixed(1)) + " (" + _toDisplayString(_unref(getDifficultyDegree)(__props.data.difficulty)) + ") ", 1)]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_5, [_createVNode(_unref(ElImage), {
        src: __props.data.image_url,
        fit: "cover",
        draggable: "false"
      }, null, 8, ["src"])])]), _cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "divider"
      }, null, -1)), _createElementVNode("div", _hoisted_6, [_createVNode(_unref(ElRow), {
        class: "detail-info-row"
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElIcon), {
          size: 14
        }, {
          default: _withCtx(() => [_createVNode(_unref(PriceTag))]),
          _: 1
        }), _createElementVNode("text", null, "剧本标签：" + _toDisplayString(__props.data.tendency), 1)]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        class: "detail-info-row"
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElIcon), {
          size: 14
        }, {
          default: _withCtx(() => [_createVNode(_unref(Timer))]),
          _: 1
        }), _createElementVNode("text", null, "预期长度：" + _toDisplayString(__props.data.construction_period), 1)]),
        _: 1
      }), _createElementVNode("text", _hoisted_7, "      " + _toDisplayString(__props.data.description), 1), __props.data.oddment ? (_openBlock(), _createElementBlock("text", _hoisted_8, "（" + _toDisplayString(__props.data.oddment) + "）", 1)) : _createCommentVNode("", true)])]);
    };
  }

};